import React from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.css';
import Footer from '../components/Footer';

const AboutPage = () => {
  return (
    <>
        <div className="about-container">
          <h1>About GK Technologies</h1>
          <p>
            GK Technologies is focused on making AI simple, practical, and powerful for everyday businesses.
          </p>
          <p>
            Our flagship platform, <strong>Taren</strong>, is an AI data assistant that instantly transforms messy business data into clear, actionable insights—helping you see what’s driving results and where to improve.
          </p>
          <p>
            From tracking sales trends to uncovering hidden opportunities, Taren automates the analytics process so you can focus on what matters most: running and growing your business.
          </p>
          <p>
            At GK Technologies, we believe AI shouldn’t be complicated or expensive. We specialize in building intuitive, custom tools that fit seamlessly into your existing workflow—bringing advanced insights to your fingertips without the technical hassle.
          </p>
          <p>
            <strong>Want to see how AI can work for your business?</strong> Get in touch to explore a personalized demo or integration built just for you. Email us at sam@technologiesgk.com
          </p>
          <Link to="/" className="btn">Back to Home</Link>
        </div>
     <footer className="landing-footer about-footer">
            <Footer />
      </footer>
    </>
  );
};

export default AboutPage;
